<div class="filter">
  <div class="search-box search-box-status">
    <label for="statusEmpresa">Status Empresa</label>
    <select id="statusEmpresa" [formControl]="searchStatus" aria-label="Status da empresa">
      <option value="1">Ativo</option>
      <option value="2">Inativo</option>
      <option value="3">Todos</option>
    </select>
  </div>

  <div class="search-box">
    <select [formControl]="searchType" aria-label="Tipo de busca">
      <option value="1">BUSCA POR CNPJ</option>
      <option value="2">BUSCA POR RAZÃO SOCIAL</option>
    </select>
    <input
      *ngIf="searchType.value == 1"
      [(ngModel)]="filterText"
      placeholder="01.234.567/0001-00"
      [textMask]="{
        mask: fiscalNumberMask,
        guide: false,
        keepCharPositions: true
      }"
      (keypress)="onPressEnterSearchCompanies($event)"
      aria-label="Buscar empresa por CNPJ" />
    <input
      *ngIf="searchType.value == 2"
      [(ngModel)]="filterText"
      placeholder="Razão Social"
      (keypress)="onPressEnterSearchCompanies($event)"
      aria-label="Buscar empresa por razão social" />
    <button class="search-icon-container" type="button" (click)="searchCompanies(filterText)" aria-label="Buscar empresa">
      <mat-icon aria-hidden="false">search</mat-icon>
    </button>
  </div>
</div>

<ng-container *ngIf="hasCompany(); else companyList">
  <div class="company-header">
    <div class="company-card">
      <div class="company-logo">
        <img src="./assets/icons/no-logo-company-icon.svg" alt="Logo da empresa" />
      </div>
      <div class="company-data">
        <span class="company-name">{{ getCompany().getCorporateName() }}</span>
        <span class="company-cnpj"><b>CNPJ: </b>{{ getCompany().getFiscalNumber() | companyFederalNumber }}</span>
        <span class="lifes"><b>Vidas: </b>{{ getCompany().getCompanyInfo().getEmployeeCount() | number }}</span>
      </div>
    </div>
    <div class="filter-search-box">
      <input
        placeholder="Buscar pelo nome, CPF ou cartão"
        [(ngModel)]="filter"
        (keypress)="onPressEnterSearchBeneficiary($event)"
        aria-label="Buscar beneficiário por nome, CPF ou cartão" />
      <button class="search-icon-container" type="button" (click)="searchBeneficiary()" aria-label="Buscar beneficiário">
        <mat-icon aria-hidden="false">search</mat-icon>
      </button>
    </div>
  </div>

  <div class="beneficiaries-list-container">
    <div class="search-control">
      <p>{{ getResultQuantityPhrase() }}</p>
    </div>
    <div class="beneficiary-card" *ngFor="let beneficiary of getPagebleResultItems()">
      <div class="beneficiary-data">
        <div class="data-container">
          <div class="row-1">
            <p>{{ beneficiary.getName() }}</p>
          </div>
          <div class="row-2">
            <span><b>Número do cartão: </b>{{ beneficiary.getCard().getCardNumber() | cardNumberFormat }}</span>
            <div *ngIf="beneficiary.isCardBlocked()" class="card-status-container">
              <mat-icon aria-hidden="false">block</mat-icon>
              <span>BLOQUEADO</span>
            </div>
          </div>
          <div class="row-3">
            <div class="data-column">
              <span><b>CPF: </b>{{ beneficiary.getSocialNumber() | socialNumberFormatPipe }}</span>
              <span><b>Dependentes: </b>{{ beneficiary.howManyDependents() }}</span>
            </div>
            <div class="data-column">
              <span><b>Sexo: </b>{{ beneficiary.getGender().getView() }}</span>
              <span><b>Estado Civil: </b>{{ beneficiary.getMaritalStatus().getView() }}</span>
            </div>
            <div class="data-column">
              <span><b>Celular: </b>{{ beneficiary.getMobile() }}</span>
              <span><b>E-mail: </b>{{ beneficiary.getEmail() }}</span>
            </div>
          </div>
          <div class="row-4">
            <div class="beneficiary-limit">
              <span><b>Limite: </b>{{ beneficiary.getLimit() | currencyPbmPipe }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-container">
        <div
          class="btn"
          [ngStyle]="{
            'background-color': beneficiary.isActive() ? '#2DCD7A' : 'darkgray'
          }"
          aria-label="Status do beneficiário">
          <mat-icon *ngIf="beneficiary.isActive()">check_circle_outline</mat-icon>
          <mat-icon *ngIf="!beneficiary.isActive()">clear</mat-icon>
          <span class="btn-title">{{ beneficiary.isActive() ? "ATIVO" : "INATIVO" }}</span>
        </div>

        <div
          UserManagerPermission
          elementPermission="EDIT_BENEFICIARY"
          class="btn edit"
          (click)="navigateToEditBeneficiary(beneficiary)"
          aria-label="Editar ou visualizar beneficiário">
          <mat-icon aria-hidden="false">edit_note</mat-icon>
          <span class="btn-title">{{ hasAccessToEditBeneficiary() && beneficiary.isActive() ? "EDITAR" : "VISUALIZAR" }}</span>
        </div>

        <div *ngIf="hasAccessToEditCycleLimit()" class="limit-btn" (click)="openModalBeneficiaryLimit(beneficiary)" aria-label="Alterar limite do beneficiário">
          <mat-icon aria-hidden="false">attach_money</mat-icon>
          <span class="btn-title">ALTERAR LIMITE</span>
        </div>
      </div>
    </div>
    <div class="more-beneficiaries-container">
      <button
        class="more-beneficiaries-btn"
        *ngIf="showMoreBeneficiaries()"
        type="button"
        (click)="searchMoreBeneficiaries()"
        aria-label="Carregar mais beneficiários">
        <span class="btn-title">carregar mais registros</span>
      </button>
    </div>
  </div>
</ng-container>

<ng-template #companyList>
  <div class="company-card-container">
    <div class="search-control">
      <p>{{ getCompanyResultQuantityPhrase() }}</p>
      <button class="scroll-text" *ngIf="showScrollBottomBtn()" type="button" (click)="scrollToLastCompany()" aria-label="Ir para o fim da lista de empresas">
        <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
        <span class="btn-title">ir para o fim da lista</span>
      </button>
    </div>
    <div *ngFor="let company of getCompanies()">
      <div class="company-card">
        <div class="company-logo">
          <img src="./assets/icons/no-logo-company-icon.svg" alt="Logo da empresa" />
        </div>
        <div class="company-data">
          <div>
            <p class="company-name">{{ company.getCorporateName() }}</p>
            <p class="company-cnpj">CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }}</p>
            <p class="company-description">{{ company.getTradingName() }}</p>
          </div>
        </div>
        <div class="company-status">
          <div
            class="status"
            [ngStyle]="{
              'background-color': company.getIsActive() ? '#2DCD7A' : 'darkgray'
            }"
            aria-label="Status da empresa">
            <mat-icon *ngIf="company.getIsActive()">check_circle_outline</mat-icon>
            <mat-icon *ngIf="!company.getIsActive()">clear</mat-icon>
            <span class="btn-title">{{ company.getIsActive() ? "ATIVO" : "INATIVO" }}</span>
          </div>
          <button class="edit-btn" type="button" (click)="navigateToCompanyBeneficiaries(company)" aria-label="Editar ou visualizar empresa">
            <mat-icon aria-hidden="false">edit_note</mat-icon>
            {{ hasAccessToEditBeneficiary() ? "EDITAR" : "VISUALIZAR" }}
          </button>
        </div>
      </div>
    </div>
    <div class="more-companies-container">
      <button class="more-companies-btn" *ngIf="showMoreCompaniesBtn()" type="button" (click)="searchMoreCompanies()" aria-label="Carregar mais empresas">
        carregar mais registros
      </button>
    </div>
    <div id="bottom"></div>
  </div>
</ng-template>
